import { Screenshot } from './Screenshot';

export class ErrorInformationFromUser {
    public OrderId: number;
    public ErrorText: string;
    public OriginUrl: string;
    public Route: string;
    public WindowHeight: number;
    public WindowWidth: number;
    public Screenshot: Screenshot;
}
